export const MANAGE_OFFERINGS_LEARN_MORE_HREFS = {
  MANAGE_OFFERING:
    "https://support.exlyapp.com/support/solutions/folders/84000349370",
};

export const MANAGE_OFFERING_ASSETS_RELATIVE_PATH =
  "assets/vectors/manage_offering";
export const MANAGE_OFFERINGS_FEATURE_KEY = "mylisting";
export const MANAGE_OFFERINGS_HEADER_TITLE = "Manage Offering";
